import { doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { db } from '@/config/firebase';

const WORKSPACE_EMAIL_BLACKLIST_COLLECTION = 'workspace_email_blacklist';

const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export type BlacklistEntry = {
  email: string;
  reason?: string;
  createdByUid: string;
  createdByEmail?: string | null;
  createdByName?: string | null;
  createdAt: Date;
};

export async function addEmailToWorkspaceBlacklist(
  email: string,
  user: { uid: string; email?: string | null; displayName?: string | null },
  reason?: string,
): Promise<void> {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) {
    throw new Error('E-mail inválido para blacklist.');
  }

  const docRef = doc(db, WORKSPACE_EMAIL_BLACKLIST_COLLECTION, normalizedEmail);
  await setDoc(
    docRef,
    {
      email: normalizedEmail,
      reason: reason ?? null,
      createdByUid: user.uid,
      createdByEmail: user.email ?? null,
      createdByName: user.displayName ?? null,
      createdAt: serverTimestamp(),
    },
    { merge: true },
  );
}
